<template>
  <div 
    class="tagAddListWrap" 
    :class="tagOptionPopAddListViewBln ? 'active' : null " 
    @click="closeHandler"
    >
    <section 
      ref="tagAddListWrap" 
      class="contentWrap" 
    >
      <h2>{{ crntTag?.name }}명 입력</h2>
      <InputSrchWrap />
      <SrchList />
      <button class="closeBtn" @click="setTagOptionPopAddListViewBln({ bln : false }); setCallbackFunc( null ) ;">
        <svg viewBox="0 0 14 14" fill="none">
          <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#333333"/>
        </svg>
        <span>닫기</span>
      </button>
    </section>
  </div>
</template>

<script>
import colors , { tagsArr } from "@/plugins/wApi/colors";
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew";
import TagAddPopComm from "@TagAddPop/TagAddPopComm"; 

import InputSrchWrap from "./comp/InputSrchWrap"; 
import SrchList from "./comp/SrchList"; 



export default {
  mixins : [ TagAddPopComm ] , 
  components : {
    InputSrchWrap , 
    SrchList , 
  } , 
  data () {
    return {
      viewBln : false , 
    }
  } , 
  watch : {
    tagOptionPopAddListViewBln ( viewBln ) {
      if ( viewBln ) {
        this.setTagAddPopWrapViewBln({ bln : false }) ; 
        this.setTagOptionPopListViewBln({ bln : false }) ; 
      }
    } , 
  } , 
  mounted () {
    window.addEventListener('popstate', this.unmountHandler ) ;
  } , 
  beforeDestroy () {
    window.removeEventListener('popstate', this.unmountHandler ) ;
  } , 
  methods : {
    unmountHandler () {

    } , 
    btnClickHandler () {
      this.setTagOptionPopAddListViewBln({ bln : false }) ; 
    } , 
    closeHandler ( e ) {
      let { $refs : { tagAddListWrap }} = this ; 
      if ( !tagAddListWrap.contains( e.target )) {
        this.setCallbackFunc( null ) ;
        this.setTagOptionPopAddListViewBln({ bln : false }) ; 
      } 
    } , 
  }
}
</script>

<style lang="scss">
  .tagAddListWrap {
    position: fixed; 
    z-index: 10; 
    left: 0; top: 0; width: 100%; height: 100%; 
    display: flex; 
    justify-content: center; align-items: center; 
    visibility: hidden; 
    transition: visibility 0.475s , backdrop-filter 0.475s; 
    backdrop-filter: blur( 0px ); 

    .contentWrap {
      --width: 300px; 
      --height: 600px; 
      padding: 24px; 
      display: flex; 
      flex-direction: column; 
      gap: var( --default-gap ); 
      // position: fixed; 
      // left: calc( 50% - var( --width ) / 2 ); top: calc( 50% - var( --height ) / 2 ); 
      border: 1px solid $gray-9; 
      box-shadow: 0px 4px var( --default-gap ) rgba(91, 91, 91, 0.3); 
      width: var( --width ); height: var( --height ); 
      background-color: $white; 
      transform: scale( 0 ); 
      transition-property: transform; 
      transition-duration: 0.475s; 
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);

      > h2 {
        height: 24px; 
        display: flex; 
        flex-shrink: 0; 
        align-items: center; 
      }

      .closeBtn {
        font-size: 0; 
        width: 24px; height: 24px; 
        display: flex; 
        justify-content: center; 
        align-items: center; 
        position: absolute; 
        right: 24px; top: 24px; 
        cursor: pointer;
        svg {
          width: 14px; height: 14px; 
        }
      } // end of .close
    } // end of contentWrap

    &.active {
      visibility: visible; 
      // backdrop-filter: blur( 2px ); 
      .contentWrap {
        transform: scale( 1 ); 
      }
    }
  } // end of tagAddListWrap 
</style>